enum IUiType {
    BROWSER = 'BROWSER'
}

export default IUiType;